export default __webpack_public_path__ + "static/my_image_4-93286dc685216af294c898408ff01bb2.png";